import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { GlobalSearchCardsResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { queryKeys } from "./queryKeys.ts";

export const useDeleteCardFromGlobalSearchCache = (projectId: string) => {
  const queryClient = useQueryClient();

  return useCallback(
    (id: string) => {
      queryClient.setQueriesData<GlobalSearchCardsResponse>(
        { queryKey: queryKeys.globalSearchCardsAllResults() },
        (old) => {
          const filteredResponse: GlobalSearchCardsResponse = {
            cards:
              old?.cards.filter(
                (card) => card.id !== id || card.projectId !== projectId,
              ) || [],
            hasMore: old?.hasMore || false,
          };
          return filteredResponse;
        },
      );
    },
    [queryClient, projectId],
  );
};
